import React, { useRef, useEffect } from "react";

import uploadSvg from "assets/images/icons/uploadSvg.svg";

import classes from "./style.module.scss";

// The drop zone only. The upload itself lives in OrgLogo, so the cursor, the progress and the
// alert are driven from one place whichever of the two surfaces started it.
const UploadLogo = ({ handleUpload, uploadState, setUploadState }) => {
    const ref = useRef(null);

    useEffect(() => {
        const node = ref.current;

        if (!node) return;

        const handleDragOver = (event) => {
            event.preventDefault();
            event.stopPropagation();

            setUploadState((prev) => ({ ...prev, isDraggingOver: event.type === "dragenter" }));
        };

        node.addEventListener("dragenter", handleDragOver);
        node.addEventListener("dragleave", handleDragOver);

        return () => {
            node.removeEventListener("dragenter", handleDragOver);
            node.removeEventListener("dragleave", handleDragOver);
        };
    }, [setUploadState]);

    return (
        <div
            ref={ref}
            className={`${classes.uploadLogoContainer}`}
            style={{
                border:
                    uploadState.isDraggingOver || uploadState.isUploading ? "1px solid #62BCF8" : "1px dashed #62BCF8",
                backgroundColor: uploadState.isDraggingOver || uploadState.isUploading ? "#FFFFFF" : "",
            }}
            onDrop={(e) => handleUpload(e, true)}
        >
            {uploadState.isUploading ? (
                <>
                    <p style={{ fontSize: "0.75rem" }}>
                        Uploading <b>{uploadState.progress}%</b>
                    </p>
                    <div className={classes.loaderWrapper}>
                        <div className={classes.loader} style={{ width: `${uploadState.progress}%` }}></div>
                    </div>
                </>
            ) : (
                <>
                    <div className={classes.dropIconTextWrapper}>
                        <img src={uploadSvg} alt="Upload icon" />
                        <p>
                            Drag and drop or <span style={{ color: "#0049C6" }}>browse files</span>
                        </p>
                    </div>
                    <span className={`${classes.dropSubText}`}>(.jpeg, .png, .svg)</span>
                    <input
                        className={classes.dragAndDropInput}
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleUpload(e, false)}
                    />
                </>
            )}
        </div>
    );
};

export default UploadLogo;
